// Where the user is in the wizard: on wide screens a vertical list beside the card, each done
// step showing what was chosen and reachable again with a click; on narrow screens the card's
// own progress bar (StepHeader) does the job.
import { Check } from "@phosphor-icons/react";

import { cn } from "../../../ui/cn";

export interface RailStep {
  key: string;
  label: string;
  /** What was chosen, once the step is done. */
  summary?: string;
}

export function StepRail({ steps, current, reachable, onJump, label }: { steps: RailStep[]; current: number; reachable: number; onJump: (i: number) => void; label: string }) {
  return (
    <nav aria-label={label} className="hidden lg:block">
      <ol className="sticky top-24 m-0 list-none space-y-1 p-0">
        {steps.map((s, i) => {
          const done = i < current;
          const here = i === current;
          return (
            <li key={s.key} className="relative">
              {i < steps.length - 1 ? <span aria-hidden className={cn("absolute start-[19px] top-10 h-[calc(100%-1.75rem)] w-px", done ? "bg-primary" : "bg-gray-200")} /> : null}
              <button
                type="button"
                disabled={i > reachable}
                aria-current={here ? "step" : undefined}
                onClick={() => onJump(i)}
                className={cn("flex w-full items-start gap-3 rounded-lg p-1.5 text-start transition-colors enabled:hover:bg-gray-100", here && "bg-gray-0 shadow-sm dark:bg-gray-50")}
              >
                <span
                  className={cn(
                    "flex h-7 w-7 shrink-0 items-center justify-center rounded-full border-2 text-[13px] font-semibold",
                    done && "border-primary bg-primary text-primary-foreground",
                    here && "border-primary bg-primary-lighter text-primary-dark",
                    !done && !here && "border-gray-200 bg-gray-0 text-gray-500 dark:bg-gray-50",
                  )}
                >
                  {done ? <Check weight="bold" className="h-3.5 w-3.5" aria-hidden /> : i + 1}
                </span>
                <span className="min-w-0 pt-0.5">
                  <span className={cn("block text-[13.5px] font-semibold", here || done ? "text-gray-900" : "text-gray-500")}>{s.label}</span>
                  {done && s.summary ? <span className="block truncate text-xs text-gray-500">{s.summary}</span> : null}
                </span>
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
